'use es6';

import { createAction } from 'flux-actions';
import { UPDATE_SESSION_ID } from '../constants/actionTypes';
export const updateSessionId = createAction(UPDATE_SESSION_ID, sessionId => ({
  sessionId
}));